module.exports = __webpack_public_path__ + "img/6.bf7ba1a0.jpg";